import React from 'react';
import { NavLink } from 'react-router-dom';
import { useLanguage, t } from '../context/LanguageContext';
import { usePermissions } from '../context/PermissionContext';

// moduleKey/anyOf on each link must mirror the ProtectedRoute gate on that exact path in App.js —
// a factory/QA user with only sqf.checklists.view+fill used to see every tab here, click one they
// couldn't open, and land on ProtectedRoute's full-page "Access Restricted" box with no nav bar at
// all (it replaces the whole page, SqfNav included) — the only way back was the browser's Back
// button. Filtering this list to what hasModule() actually allows fixes that at the source.
const LINKS = [
  { to: '/sqf',                    end: true, en: 'Dashboard',          es: 'Panel',          moduleKey: 'sqf.checklists.view' },
  { to: '/sqf/checklists',                    en: 'Checklists',          es: 'Listas',         moduleKey: 'sqf.checklists.view' },
  { to: '/sqf/templates',                     en: 'Templates',           es: 'Plantillas',     moduleKey: 'sqf.checklists.manage' },
  { to: '/sqf/schedules',                     en: 'Schedules',           es: 'Horarios',       moduleKey: 'sqf.checklists.manage' },
  { to: '/sqf/policies',                      en: 'Policies',            es: 'Políticas',      moduleKey: 'sqf.checklists.manage' },
  { to: '/sqf/corrective-actions',            en: 'Corrective Actions',  es: 'Acciones',       moduleKey: 'sqf.checklists.corrective' },
  { to: '/sqf/contractors',                   en: 'Contractors',         es: 'Contratistas',   anyOf: ['sqf.checklists.manage', 'sqf.entrance'] },
  { to: '/sqf/visitors',                      en: 'Visitor Log',         es: 'Visitantes',     anyOf: ['sqf.checklists.manage', 'sqf.entrance'] },
  { to: '/sqf/hub',                           en: 'Audit Hub',           es: 'Hub Auditoría',  moduleKey: 'sqf.checklists.manage' },
  { to: '/sqf/training',                      en: 'Training',            es: 'Capacitación',   moduleKey: 'sqf.training.manage' },
  { to: '/sqf/food-safety',                   en: 'Food Safety Plan',    es: 'Plan Inocuidad', moduleKey: 'sqf.food_safety' },
  { to: '/sqf/temp-monitoring',               en: 'Temperature',         es: 'Temperatura',    moduleKey: 'sqf.temp_monitoring' },
  { to: '/sqf/ai-import',                     en: 'AI Import',           es: 'Importar IA',    moduleKey: 'sqf.checklists.view' },
];

export default function SqfNav() {
  const { lang } = useLanguage();
  const { hasModule } = usePermissions();
  const visibleLinks = LINKS.filter(link =>
    link.anyOf ? link.anyOf.some(hasModule) : hasModule(link.moduleKey)
  );

  return (
    <div
      style={{
        position: 'sticky',
        top: 'var(--topbar-height)',
        zIndex: 999,
        background: '#f8f9fa',
        borderBottom: '1px solid #dee2e6',
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      <div style={{ display: 'inline-flex', gap: 2, padding: '6px 12px' }}>
        {visibleLinks.map(link => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            style={({ isActive }) => ({
              display: 'inline-block',
              padding: '4px 12px',
              borderRadius: 20,
              fontSize: 13,
              fontWeight: isActive ? 600 : 400,
              color: isActive ? '#fff' : '#495057',
              background: isActive ? '#0d6efd' : 'transparent',
              textDecoration: 'none',
              transition: 'background 0.15s, color 0.15s',
              whiteSpace: 'nowrap',
            })}
          >
            {t(link.en, link.es, lang)}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
